import { render } from "./MainMenuVpos.vue?vue&type=template&id=da7f612c"
import script from "./MainMenuVpos.vue?vue&type=script&lang=js"
export * from "./MainMenuVpos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__